<style scoped lang="scss">
.header {
  position: fixed;
  left: 210px;
  right: 0;
  top: 0;
  height: 60px;
  background-color: #f0f0f0;
  width: auto;

  &::after {
    content: '';
    clear: both;
  }

  &.collapse {
    left: 64px;
  }
}

.w70 {
  width: 70px;
}

.w20 {
  width: 20px;
}
</style>
<template>
  <div class="header bb oh flex aic" :class="{collapse:collapse}">
    <div class="flex1 flex aic">
      <span class="pointer" :class="[collapse?'el-icon-s-unfold':'el-icon-s-fold']" @click="collapseChage"></span>
      <span class="ml15">{{ app === 'staff' ? '国家区域医疗中心——急重症转诊服务平台' : '体检机构管理服务平台' }}</span>
    </div>
    <ul class="flex0 pr15 flex aic">
      <div>
        <!--<el-button type="primary" size="mini" @click="download" v-if="app==='staff'">下载互视客户端</el-button>-->
        <el-button type="primary" size="mini" @click="kefu" v-if="app==='tj'">联系客服</el-button>
      </div>
      <!--<div class="fs14 w70 ml5">
          <span>联系医助</span>
      </div>
      <div class="w20 ml5">
          <span class="iconfont icon-xiaoxi"></span>
      </div>
      -->
      <div class="ml5">
        <!--<el-dropdown @command="command">
          <span class="el-dropdown-link">
              <span class="iconfont icon-shezhi"></span>
          </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>修改资料</el-dropdown-item>
                <el-dropdown-item>修改密码</el-dropdown-item>
                <el-dropdown-item command="quit">退出</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>-->
        <span class="fs14 pointer" @click="quit">退出</span>
      </div>
    </ul>
  </div>
</template>
<script>

import {tokenCache} from "../lib/cache/Token";
import {AppMixin} from "../lib/mixins/app";
import {EVENT_LOGOUT_SUCCESS} from "../../modules/account/events";
import {loginInfoCache} from "@/common/lib/cache/LoginInfo";
import {loginTeamCache} from "@/common/lib/cache/LoginTeam";

export default {
  name: 'app-header',
  components: {},
  mixins: [AppMixin],
  data() {
    return {
      collapse: false,
    }
  },
  created() {

  },
  computed: {},
  methods: {
    download() {
      location.href = this.env.hushi_exe_download;
    },
    kefu() {
      this.$alert('客服电话：0571-87767077');
    },
    quit() {
      this.$confirm('是否退出登录？')
          .then(() => {
            tokenCache.set('');
            loginInfoCache.set(null);
            loginTeamCache.set(null);
            if (this.app === 'staff') {
              this.$router.push('/account/login?callback=' + encodeURIComponent(this.$route.fullPath));
              bus.$emit(EVENT_LOGOUT_SUCCESS, 1);
            } else location.reload();
          })
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit('collapse', this.collapse);
    },
  }
}
</script>
